import axios from 'axios';
import { PROPOSE_NOMINEE_API_URL, VOTED_NOMINATIONS_API_URL, VOTE_NOMINEE_API_URL } from '../constants/urls';

export default class VoteServices {

  static proposeNominee(params) {
    const host = params.host;
    return axios({
      withCredentials: true,
      method: 'post',
      url: host + PROPOSE_NOMINEE_API_URL,
      data: params,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((result) => {
        return result.data.status === 200;
      })
      .catch((error) => {
        /* eslint-disable no-console */
        console.error(error);
        throw error;
      });
  }

  static fetchNominationsVoted(params) {
    const host = params.host;
    let voter = '';

    if (params && params.voter) {
      voter = params.voter;
    }

    const query = {
      voter: voter,
    };

    const url = host + VOTED_NOMINATIONS_API_URL;
    return axios({
      withCredentials: true,
      method: 'GET',
      url,
      params: query
    })
      .then((result) => {
        const arrayNominations = result.data;
        const resultArray = [];

        if (arrayNominations.length === 0) {
          return [];
        }

        for (let i = 0; i < arrayNominations.length; i += 1) {
          resultArray[i] = {
            name: arrayNominations[i].originName,
            nominationId: Number(arrayNominations[i].rubricId),
            id: Number(arrayNominations[i].id),
            isRevoteAllowed: arrayNominations[i].isRevoteAllowed
          };
        }

        return resultArray;
      })
      .catch((error) => {
        /* eslint-disable no-console */
        console.error(error);
      });
  }

  static voteNominee(params) {
    const host = params.host;
    return axios({
      withCredentials: true,
      method: 'post',
      url: host + VOTE_NOMINEE_API_URL,
      data: params,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((result) => {
        if (result.data.status === 200) {
          const region = params.region;
          const goalsName = {
            66: 'AW2018VOTE',
            54: 'AW2019VOTE'
          };

          const eventCategory = {
            66: 'E1award2018',
            54: 'NGSaward2019'
          };

          if (typeof yaCounter6874273 !== 'undefined' && region == 66) {
            yaCounter6874273.reachGoal(goalsName[region]);
          }

          if (typeof yaCounter1337757 !== 'undefined' && region == 54) {
            yaCounter1337757.reachGoal(goalsName[region]);
          }

          if (typeof ga !== 'undefined') {
            ga('send', {
              hitType: 'event',
              eventCategory: eventCategory[region],
              eventAction: goalsName[region]
            });
          }
        }
        return result;
      })
      .catch((error) => {
        /* eslint-disable no-console */
        console.error(error);

        if (error.response) {
          return error.response;
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/services/Vote.js